import ComponentCard from "../../components/common/ComponentCard";
import ListComponent from "../../components/common/ListComponent";
import React from "react";
import PageMeta from "../../components/common/PageMeta";

const TeammateList = () => {
    return (
        <>
            <PageMeta title="Danh sách bài viết" description="Trang danh sách bài viết"/>
            <div className="space-y-6">
                <ComponentCard title="">
                    <ListComponent type="4" router="teammate" />
                </ComponentCard>
            </div>
        </>
    );
};

export default TeammateList;